const stylesWMS = {
    itemName: {
        color: "#00bfff",
        fontSize: 25
    },
    deleteButtonAlert: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        marginRight: 10,
        fontSize: 25
    },
    cardBackgroundColorDetail: {
        backgroundColor: "#ffffff",
        height: 400,
        overflowY: "scroll"
    },
    TransfersBackground: {
        backgroundColor: "white",
        padding: 150,
        marginTop: 50
    },
    mainContainer: {
        backgroundColor: "#e6e6fa",
        height: "100%"
    },
    deleteButtonAlertTransfer: {

        marginRight: 10
    },
    cancelButtonAlertTransfer: {
        marginRight: 10
    },
    InputBar: {
        width: "60%"
    },
    InputGroup: {
        width: "40%"
    },
    selectedItem: {
        backgroundColor: "#e6e6fa",
        padding: 20
    },
    unselectedItem: {
        padding: 20
    },
    trashTransfer: {
        marginRight: 20
    },
    counter: {
        height: 70,
        width: 200,
        marginLeft: 20
    },
    InputRequired: {
        borderColor: "red"
    },
    inputTable: {
        height: "10%",
    },
    scroll: {
        overflowY: "scroll",
        height: 300
    },
    datelocation: {
        width: 300
    },
    Alert: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        fontSize: 16,
        width: 100
    },
    transactionButton: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        fontSize: 16,
        width: 150
    },
    rightDirection: {
        float: "right",
        textAlign: "right"
    },
    wideButton: {
        backgroundColor: '#00bfff',
        borderColor: '#00bfff',
        color: '#ffffff',
        width: 250
    },
}
export default stylesWMS